/**
 * Generated by orval 🍺
 * Do not edit manually.
 * GTA CRM Demo API
 * GTA CRM 生产级 demo 的只读+轻写 API(feat-008;demo-scoped,零 model 零迁移)。
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `xhs` - 小红书
 * * `wechat` - 微信
 * * `email` - 邮件
 * * `tiktok` - TikTok
 * * `instagram` - Instagram
 * * `whatsapp` - WhatsApp
 * * `douyin` - 抖音
 * * `facebook` - Facebook
 * * `line` - LINE
 * * `telegram` - Telegram
 * * `youtube` - YouTube
 * * `website_chat` - 网站在线咨询
 * * `salesmartly` - SalesSmartly 聚合平台联系人
 */
export type ExternalIdentitySourceEnum =
  (typeof ExternalIdentitySourceEnum)[keyof typeof ExternalIdentitySourceEnum];

export const ExternalIdentitySourceEnum = {
  xhs: "xhs",
  wechat: "wechat",
  email: "email",
  tiktok: "tiktok",
  instagram: "instagram",
  whatsapp: "whatsapp",
  douyin: "douyin",
  facebook: "facebook",
  line: "line",
  telegram: "telegram",
  youtube: "youtube",
  website_chat: "website_chat",
  salesmartly: "salesmartly",
} as const;
